<template>
  <span v-if="!dummy" :class="`pix-member-circle ${clickable && !dummy ? 'pix-member-circle--clickable' : ''}`" :title="formattedName" @click="emitClick">
    <span>{{ initials }}</span>
  </span>
  <span v-else :class="`pix-member-circle ${clickable && !dummy ? 'pix-member-circle--clickable' : ''}`" :title="formattedName" @click="emitClick">
    <span>{{ dummyText }}</span>
  </span>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'pix-member-circle',

  props: {
    name: { type: String, default: '' },
    clickable: { type: Boolean, default: false },
    dummy: { type: Boolean, default: false },
    dummyText: { type: String, default: '' },
  },

  computed: {
    initials() {
      if (!this.name) return '';

      const separatedByDot = this.name?.split('.');
      const ret = `${separatedByDot[0][0]}${separatedByDot[1][0]}`;
      return ret.toUpperCase();
    },
    formattedName() {
      if (!this.name) return '';

      const separatedByDot = this.name?.split('@')[0]?.split('.');
      return `${_.capitalize(separatedByDot[0])} ${_.capitalize(separatedByDot[1])}`;
    },
  },

  methods: {
    emitClick() {
      if (this.clickable) this.$emit('click', this.name);
    },
  },
};
</script>

<style scoped>
.pix-member-circle {
  border-radius: 50%;
  background-color: #ebecec;
  border: solid 1px #b1b2b4;
  /* padding: 4px; */
  font-size: 14px;
  margin-left: -5px;
  /* max-height: 28.27px;
  max-width: 28.27px;
  min-width: 27.27px;
  text-align: center; */
  transition: background 0.2s ease-in;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  min-height: 28px;
}

.pix-member-circle--clickable:hover {
  cursor: pointer;
  background-color: var(--jll-concrete);
}
</style>
